'use strict';

var SpecialEventsGridDirective = function SpecialEventsGridDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/special-events-grid.html'),
    requires: '^rmNewCalendar',
    controller: 'SpecialEventsGridController',
    scope: {
      gridId: '@',
      calendarModeLabel: '@',
      displayedCalendar: '=',
      readOnly: '='
    },
    link: function link(scope, element) {
      element.on('cellendedit', scope.setEventType);
      scope.initEventsGrid();
      scope.$watch('displayedCalendar.specialEvents', scope.handleSpecialEventUpdates);
    }
  };
};
SpecialEventsGridDirective.$inject = [];
module.exports = SpecialEventsGridDirective;